import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//SELECT sa_id,sa_title,sa_cover,sa_top_img,sa_share_icon FROM `scms_articles` where sc_id>1

const article1={
  'title':'专访捷豹路虎胡波：市场部的新职责是变成编辑部',
  'second_title':'捷豹路虎 胡波',
  'brief':'对于优质内容和精良制作有着高要求的高端品牌而言，BGC（品牌生产内容）和市场部的媒体化是大势所趋。',
  'shortbrief':'对于优质内容和精良制作有着高要求的高端品牌而言，BGC（品牌生产内容）和市场部的媒体化是大势所趋。',
  'share_title':'专访捷豹路虎胡波： 市场部的新职责是变成编辑部',
  'share_des':'对于优质内容和精良制作有着高要求的高端品牌而言，BGC（品牌生产内容）和市场部的媒体化是大势所趋。',
  'date':'2020-06-30'
}
const article2={
  'title':'专访伊利郭云龙：不止于电商，快消直播的新探索',
  'second_title':'伊利 郭云龙',
  'brief':'伊利正通过与渠道合作伙伴联合开播，尤其是与具有020能力的渠道商联合开播的形式，为“快”消提速。',
  'shortbrief':'伊利正通过与渠道合作伙伴联合开播，尤其是与具有020能力的渠道商联合开播的形式，为“快”消提速。',
  'share_title':'专访伊利郭云龙： 不止于电商，快消直播的新探索',
  'share_des':'伊利正通过与渠道合作伙伴联合开播，尤其是与具有020能力的渠道商联合开播的形式，为“快”消提速。',
  'date':'2020-06-30'
}
const article3={
  'title':'专访携程梁建章：高管直播不是制造话题，而是创造机会',
  'second_title':'携程 梁建章',
  'brief':'对梁建章这样的企业家而言，亲自下场直播只是展现携程对产品信心及用户需求的一个侧写。',
  'shortbrief':'对梁建章这样的企业家而言，亲自下场直播只是展现携程对产品信心及用户需求的一个侧写。',
  'share_title':'专访携程梁建章：高管直播不是制造话题，而是创造机会',
  'share_des':'对梁建章这样的企业家而言，亲自下场直播只是展现携程对产品信心及用户需求的一个侧写。',
  'date':'2020-06-30'
}
const article4={
  'title':'碧桂园的进击与突围，为房企直播打开新端口',
  'second_title':'碧桂园 郑岚',
  'brief':'在碧桂园下场前，很少有人会关注到房产企业也可以登上直播的舞台。',
  'shortbrief':'在碧桂园下场前，很少有人会关注到房产企业也可以登上直播的舞台。',
  'share_title':'碧桂园的进击与突围， 为房企直播打开新端口',
  'share_des':'在碧桂园下场前，很少有人会关注到房产企业也可以登上直播的舞台。',
  'date':'2020-06-30'
}
const article5={
  'title':'解锁直播新思路',
  'second_title':'第一财经 x 动见',
  'brief':'直播为企业带来了哪些改变?企业的内容运营该怎么做?四机构分享了他们的操盘经验。',
  'shortbrief':'直播为企业带来了哪些改变?企业的内容运营该怎么做?四机构分享了他们的操盘经验。',
  'share_title':'解锁直播新思路',
  'share_des':'直播为企业带来了哪些改变?企业的内容运营该怎么做?四机构分享了他们的操盘经验。',
  'date':'2020-06-30'
}
const article6={
  'title':'数据之眼看直播',
  'second_title':'5大数据机构加入讨论，以数据洞 悉直播热潮背后的变革动因，解析直播营销未来的发展前景。',
  'brief':'5大数据机构加入讨论，以数据洞悉直播热潮背后的变革动因，解析直播营销未来的发展前景。',
  'shortbrief':'5大数据机构加入讨论，以数据洞悉直播热潮背后的变革动因，解析直播营销未来的发展前景。',
  'share_title':'数据之眼看直播',
  'share_des':'5大数据机构加入讨论，以数据洞悉直播热潮背后的变革动因，解析直播营销未来的发展前景。',
  'date':'2020-06-30'
}
const article7={
  'title':'直播是零售效率的第三次飞跃',
  'second_title':'第一财经 x 动见',
  'brief':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
  'shortbrief':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
  'share_title':'直播是零售效率的第三次飞跃',
  'share_des':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
  'date':'2020-06-30'
}
const article8={
  'title':'在抖音直播带货需要了解的三件事',
  'second_title':'第一财经 x 动见',
  'brief':'直播带货的第一步不是直播，而是内容。',
  'shortbrief':'直播带货的第一步不是直播，而是内容。',
  'share_title':'在抖音直播带货需要了解的三件事',
  'share_des':'直播带货的第一步不是直播，而是内容。',
  'date':'2020-06-30'
}
const article9={
  'title':'灵魂三问，企业到底想从直播中得到什么？',
  'second_title':'第一财经 x 动见',
  'brief':'我们采访到了10家不同领域的企业，想通过了解他们通过实践的观点总结，分享出一些企业对于直播价值的思考与认识。',
  'shortbrief':'我们采访到了10家不同领域的企业，想通过了解他们通过实践的观点总结，分享出一些企业对于直播价值的思考与认识。',
  'share_title':'灵魂三问，企业到底想从直播中得到什么？',
  'share_des':'我们采访到了10家不同领域的企业，想通过了解他们通过实践的观点总结，分享出一些企业对于直播价值的思考与认识。',
  'date':'2020-06-30'
}
const article10={
  'title':'数说直播营销',
  'second_title':'第一财经 x 动见',
  'brief':'不大的直播间里，正创造着巨大的财富。',
  'shortbrief':'不大的直播间里，正创造着巨大的财富。',
  'share_title':'新营销时代的增长创意',
  'share_des':'不大的直播间里，正创造着巨大的财富。',
  'date':'2020-06-30'
}
const article11={
  'title':'罗永浩的直播初体验：带货不靠讲段子',
  'second_title':'罗永浩',
  'brief':'现在说直播，大家通常还停留在带货的阶段。但如果你运用好这个机会，其实它可能成为一个超级孵化器。',
  'shortbrief':'现在说直播，大家通常还停留在带货的阶段。但如果你运用好这个机会，其实它可能成为一个超级孵化器。',
  'share_title':'罗永浩的直播初体验：带货不靠讲段子',
  'share_des':'现在说直播，大家通常还停留在带货的阶段。但如果你运用好这个机会，其实它可能成为一个超级孵化器。',
  'date':'2020-06-30'
}
const article12={
  'title':'媒介角度告诉你，这才是真正的直播',
  'second_title':'群邑智库总经理 方骏',
  'brief':'很多企业把直播当成一场运动，运动完成了，直播就结束了。',
  'shortbrief':'很多企业把直播当成一场运动，运动完成了，直播就结束了。',
  'share_title':'媒介角度告诉你，这才是真正的直播',
  'share_des':'很多企业把直播当成一场运动，运动完成了，直播就结束了。',
  'date':'2020-06-30'
}
const article13={
  'title':'光环终将褪去，直播还需扎实运营',
  'second_title':'纷析数据创始人 宋星',
  'brief':'目前，直播正在走向成熟和主流，企业也正在走进营销的后直播时代。但与其说这是直播的时代，不如说这是新的品牌传播的时代。',
  'shortbrief':'目前，直播正在走向成熟和主流，企业也正在走进营销的后直播时代。但与其说这是直播的时代，不如说这是新的品牌传播的时代。',
  'share_title':'光环终将褪去，直播还需扎实运营',
  'share_des':'目前，直播正在走向成熟和主流，企业也正在走进营销的后直播时代。但与其说这是直播的时代，不如说这是新的品牌传播的时代。',
  'date':'2020-06-30'
}
const article14={
  'title':'直播带货热潮下的冷静思考',
  'second_title':'中欧国际工商学院市场营销学教授 王高',
  'brief':'企业首先需要解决的问题就是观众从哪里来。这是企业自播最大的挑战，也可能是一个非常“昂贵”的挑战',
  'shortbrief':'企业首先需要解决的问题就是观众从哪里来。这是企业自播最大的挑战，也可能是一个非常“昂贵”的挑战',
  'share_title':'直播带货热潮下的冷静思考',
  'share_des':'企业首先需要解决的问题就是观众从哪里来。这是企业自播最大的挑战，也可能是一个非常“昂贵”的挑战',
  'date':'2020-06-30'
}
const article15={
  'title':'入局直播，企业应具备战略思维',
  'second_title':'罗兰贝格管理咨询全球高级合伙人兼大中华区副总裁 陈科',
  'brief':'企业应关注直播电商，直播营销模式带来的价值变革，打造长期可持续的直播战略。',
  'shortbrief':'企业应关注直播电商，直播营销模式带来的价值变革，打造长期可持续的直播战略。',
  'share_title':'入局直播，企业应具备战略思维',
  'share_des':'企业应关注直播电商，直播营销模式带来的价值变革，打造长期可持续的直播战略。',
  'date':'2020-06-30'
}
const article16={
  'title':'直播驶往“应许之地”',
  'second_title':'陈都烨 巨量引擎营销副总裁',
  'brief':'直播驶往的目的地将是一片蕴藏富矿的“应许之地”，但前提是在抵达之前需要不断试错并最终找到正确的那条路径。',
  'shortbrief':'直播驶往的目的地将是一片蕴藏富矿的“应许之地”，但前提是在抵达之前需要不断试错并最终找到正确的那条路径。',
  'share_title':'直播驶往“应许之地”',
  'share_des':'直播驶往的目的地将是一片蕴藏富矿的“应许之地”，但前提是在抵达之前需要不断试错并最终找到正确的那条路径。',
  'date':'2020-06-30'
}
const article17={
  'title':'欢迎来到后直播时代',
  'second_title':'何刚 《哈佛商业评论》中文版主编',
  'brief':'在每一个被定义的时代中，表象是技术的更迭，内核是商业的不断探索、尝试和应用。',
  'shortbrief':'在每一个被定义的时代中，表象是技术的更迭，内核是商业的不断探索、尝试和应用。',
  'share_title':'欢迎来到后直播时代',
  'share_des':'在每一个被定义的时代中，表象是技术的更迭，内核是商业的不断探索、尝试和应用。',
  'date':'2020-06-30'
}
const article18={
  'title':'营销的后直播时代',
  'second_title':'第一财经 x 动见',
  'brief':'唯有亲历者，才能够真实地还原直播的原貌',
  'shortbrief':'唯有亲历者，才能够真实地还原直播的原貌',
  'share_title':'营销的后直播时代',
  'share_des':'唯有亲历者，才能够真实地还原直播的原貌',
  'date':'2020-06-30'
}
// const article7={
//   'title':'直播是零售效率的第三次飞跃',
//   'second_title':'第一财经 x 动见',
//   'brief':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
//   'shortbrief':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
//   'share_title':'直播是零售效率的第三次飞跃',
//   'share_des':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
//   'date':'2020-06-30'
// }
// const article7={
//   'title':'直播是零售效率的第三次飞跃',
//   'second_title':'第一财经 x 动见',
//   'brief':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
//   'shortbrief':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
//   'share_title':'直播是零售效率的第三次飞跃',
//   'share_des':'移动互联网人口红利见顶已成事实，但直播带货作为较新颖的零售形式,仍存在一些新红利尚待企业挖掘。',
//   'date':'2020-06-30'
// }
// const article6={
//   'title':'数据之眼看直播',
//   'second_title':'5大数据机构加入讨论，以数据洞 悉直播热潮背后的变革动因，解析直播营销未来的发展前景。',
//   'brief':'5大数据机构加入讨论，以数据洞悉直播热潮背后的变革动因，解析直播营销未来的发展前景。',
//   'shortbrief':'5大数据机构加入讨论，以数据洞悉直播热潮背后的变革动因，解析直播营销未来的发展前景。',
//   'share_title':'数据之眼看直播',
//   'share_des':'5大数据机构加入讨论，以数据洞悉直播热潮背后的变革动因，解析直播营销未来的发展前景。',
//   'date':'2020-06-30'
// }
// const article9={
//   'title':'灵魂三问，企业到底想从直播中得到什么？',
//   'second_title':'第一财经 x 动见',
//   'brief':'我们采访到了10家不同领域的企业，想通过了解他们通过实践的观点总结，分享出一些企业对于直播价值的思考与认识。',
//   'shortbrief':'我们采访到了10家不同领域的企业，想通过了解他们通过实践的观点总结，分享出一些企业对于直播价值的思考与认识。',
//   'share_title':'灵魂三问，企业到底想从直播中得到什么？',
//   'share_des':'我们采访到了10家不同领域的企业，想通过了解他们通过实践的观点总结，分享出一些企业对于直播价值的思考与认识。',
//   'date':'2020-06-30'
// }
// const article5={
//   'title':'解锁直播新思路',
//   'second_title':'第一财经 x 动见',
//   'brief':'直播为企业带来了哪些改变?企业的内容运营该怎么做?四机构分享了他们的操盘经验。',
//   'shortbrief':'直播为企业带来了哪些改变?企业的内容运营该怎么做?四机构分享了他们的操盘经验。',
//   'share_title':'解锁直播新思路',
//   'share_des':'直播为企业带来了哪些改变?企业的内容运营该怎么做?四机构分享了他们的操盘经验。',
//   'date':'2020-06-30'
// }
// const article14={
//   'title':'直播带货热潮下的冷静思考',
//   'second_title':'中欧国际工商学院市场营销学教授 王高',
//   'brief':'企业首先需要解决的问题就是观众从哪里来。这是企业自播最大的挑战，也可能是一个非常“昂贵”的挑战',
//   'shortbrief':'企业首先需要解决的问题就是观众从哪里来。这是企业自播最大的挑战，也可能是一个非常“昂贵”的挑战',
//   'share_title':'直播带货热潮下的冷静思考',
//   'share_des':'企业首先需要解决的问题就是观众从哪里来。这是企业自播最大的挑战，也可能是一个非常“昂贵”的挑战',
//   'date':'2020-06-30'
// }

export default new Vuex.Store({
  state: {
    articles:[
      article1,article2,article3,article4,article5,
      article6,article7,article8,article9,article10,
      article11,article12,article13,article14,article15
    ],
    classes:['推荐',"后直播时代","人物说"],
    class1:{
      marquees:[],
      banner:[],
      list:[]
    },
    class2:{
      marquees:[],
      banner:[],
      list:[0,1,2,3,4,5,6,7,8,9]
    },
    class3:{
      marquees:[10],
      banner:[],
      list:[11,12,13,14]
    }
  },
  mutations: {
  }
})



// WEBPACK FOOTER //
// ./src/store/articlesStore_1.js